class Details {
    private items: HTMLDetailsElement[];
    private animationDuration: number = 300;

    init(items: HTMLDetailsElement[]): void {
        this.items = items;

        this._bindEvents();
    }

    _bindEvents(): void {
        this.items.forEach((item: HTMLDetailsElement) => {
            const title = item.querySelector('.j-details__title') as HTMLElement;
            const text = item.querySelector('.j-details__text') as HTMLElement;

            title.addEventListener('click', (event: MouseEvent) => {
                this.setHeight(text);
                this.onClick(event, item);
            });
        });
    }

    private setHeight(text: HTMLElement): void {
        text.style.setProperty('--details-height', `${text.scrollHeight}px`);
    }

    private onClick(event: MouseEvent, item: HTMLDetailsElement): void {
        let isAnimating = true;

        item.classList.toggle('is-open');
        item.classList.add('is-animating');

        setTimeout(() => {
            item.classList.remove('is-animating');
        }, this.animationDuration);

        if (item.open) {
            event.preventDefault();

            if (isAnimating) {
                return;
            }

            setTimeout(() => {
                item.open = false;
                isAnimating = false;
            }, this.animationDuration);
        }
    }
}

export default Details;

// document.querySelectorAll('.j-details').forEach(item => {
//     const minimizeSiblings = true
//     const question = item.querySelector('.qna__question')
//     const answer = item.querySelector('.qna__answer')
//     const cssDuration = getComputedStyle(answer).getPropertyValue('--animation-duration')
//     const animationDuration = Number.parseInt(Number.parseFloat(cssDuration) * (/\ds$/.test(cssDuration) ? 1000 : 1))
//     const setHeight = () => answer.style.setProperty('--details-height', `${answer.scrollHeight}px`)
//
//     item.classList.add('js-details')
//
//     const onClick = event => {
//         setHeight()
//
//         let isAnimating = true
//         item.classList.toggle('is-open')
//         item.classList.add('is-animating')
//
//         setTimeout(() => {
//             item.classList.remove('is-animating')
//         }, animationDuration)
//
//         if (item.open) {
//             event.preventDefault()
//             if (isAnimating) return
//             setTimeout(() => {
//                 item.open = false
//                 isAnimating = false
//             }, animationDuration)
//         }
//
//         if (!minimizeSiblings) return
//
//         const siblings = [...item.parentNode.children]
//             .filter(el => el.classList.contains('js-details'))
//             .filter(el => el !== event.target.parentNode)
//
//         for (const el of siblings) {
//             el.classList.remove('is-open')
//             setTimeout(() => {
//                 el.open = false
//             }, animationDuration)
//         }
//     }
//
//     question.addEventListener('click', onClick)
// })
